import React from 'react';

// components
import InputHOC from '../InputHOC/InputHOC';

// styles
import './InputWrapper.scss'

const InputWrapperContainer = (WrappedComponent) => (props) => {

  // for some reason RJS ui:options have two different ways of surfacing in the props
  // this function formats ui:options 
  const formatOptions = (rjProps) => {
    const { uiSchema, schema } = rjProps;
    const options = (uiSchema?.["ui:options"] || {}).title ? uiSchema["ui:options"] : rjProps.options;
    let label = options.title;

    if (label === "data-schema") {
      label = schema.title;
    }

    const res = {
      ...options,
      label,
      ...(schema.tooltip && { tooltip: schema.tooltip }),
      ...(uiSchema?.["ui:options"]?.tooltip && { tooltip: uiSchema["ui:options"].tooltip }),
    };

    if (schema.uiSchema) {
      Object.assign(res, schema.uiSchema);
      if (schema.label) {
        res.label = schema.label;
      }
    }

    return res;
  }

  return <InputHOC
    {...props}
    WrappedComponent={WrappedComponent}
    formatOptions={formatOptions} />
}

export default InputWrapperContainer;